import { Outlet } from "react-router-dom";
import MangalaHeader from "./MangalaHeader";

const MangalaLayout = () => {
    return (
        <>
            <MangalaHeader/>
            <main>
                <Outlet/>
            </main>
        </>
    )
}

export default MangalaLayout;